export const EXTRA_ACTIVITY_TIMELINE_MANAGEMENT_CLOSE_EVENT =
	'extra-activity-timeline-management:close';

export const dispatchExtraActivityTimelineManagementClose = (sourceId = null) => {
	if (typeof window === 'undefined') return;

	window.dispatchEvent(
		new CustomEvent(EXTRA_ACTIVITY_TIMELINE_MANAGEMENT_CLOSE_EVENT, {
			detail: { sourceId },
		})
	);
};

export const subscribeExtraActivityTimelineManagementClose = (callback) => {
	if (typeof window === 'undefined') return () => {};

	const handleClose = (event) => callback(event.detail ?? {});

	window.addEventListener(EXTRA_ACTIVITY_TIMELINE_MANAGEMENT_CLOSE_EVENT, handleClose);

	return () => {
		window.removeEventListener(EXTRA_ACTIVITY_TIMELINE_MANAGEMENT_CLOSE_EVENT, handleClose);
	};
};
